import {FilterItemType} from '../enum/FilterItemType'
import {IFilterGroupItem} from '../types/IFilterGroupItem'
import {IFilterItem} from '../types/IFilterItem'

/**
 * Whether a filter item is a group, and therefore whether it has `items` and a group `operator` to read.
 *
 * Worth a named guard rather than an inline comparison because the root of a filter is an item like any
 * other, and a root that is a single property item is a shape the app really produces — the chart
 * dashboard strategy builds one. Code that walked into `.items` unconditionally used to compile only
 * because every member of the union happened to carry an optional `items`.
 */
export function isFilterGroupItem(item: IFilterItem | null | undefined): item is IFilterGroupItem {
  return item?.type === FilterItemType.Group
}
